// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__IIJUi","name":"Header_name__XxbEs","birthday":"Header_birthday__353V-","skeleton":"Header_skeleton__2Owpk"};